var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeeperLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.624,
    height: 161.714,
    viewBox: "0 0 151.523 151.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    ry: 9.838,
    y: 470.029,
    x: 34.587,
    height: 151.523,
    width: 151.523,
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#02a7f2",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    transform: "translate(-34.587 -470.029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.918 579.963-38.75-40.625 97.946-59.107 34.107 34.018.045 56.026s-.078 4.054-2.424 6.237c-2.096 2.784-6.103 3.228-6.103 3.228z",
    style: {
      fill: "#6b6b6b",
      fillOpacity: 0.1592357,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-361.756 -428.356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.086 458.534a32.83 30.81 0 0 0-32.83 30.808 32.83 30.81 0 0 0 .511 5.375 25.885 28.284 0 0 0-17.431 26.698 25.885 28.284 0 0 0 25.886 28.285 25.885 28.284 0 0 0 3.881-.356h64.73a25.536 24.643 0 0 0 4.34.358 25.536 24.643 0 0 0 25.526-24.643v-.04a25.536 24.643 0 0 0-19.598-23.9 16.16 16.696 0 0 0 3.17-9.9v-.027a16.16 16.696 0 0 0-16.18-16.67 16.16 16.696 0 0 0-11.083 4.578 32.83 30.81 0 0 0-30.922-20.566z",
    style: {
      color: "#000",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    transform: "translate(-361.756 -428.356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.434 482.251v24.244l-15.658-.134c-1.786.402-1.263 2.154-1.263 2.154l25.404 25.596 24.607-25.061s.515-2.592-1.27-2.681l-14.9.126-.38-24.37z",
    style: {
      fill: "#02a7f2",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-361.756 -428.356)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeperLogo);
export default __webpack_public_path__ + "static/media/KeeperLogo.ff481be7ba49ba48a094ecdc28639138.svg";
export { ForwardRef as ReactComponent };